import { SubtypeDimension } from '@kentik/ui-shared/dictionary/v2/conversion.types';
import { AppProtocolColumn, AppProtocolRaw } from '@kentik/ui-shared/types/lookup.types';
import {
  DST_REGEXP,
  FROM_REGEXP,
  IN_REGEXP,
  OUT_REGEXP,
  SRC_REGEXP,
  TO_REGEXP
} from '@kentik/ui-shared/dictionary/v2/compilers/customDimensionConstants';

export const getSingleDirectionDimensionKeys = (dim: SubtypeDimension) =>
  [dim.src, dim.dst, dim.other].filter((k): k is string => !!k);

export const getAllDimensionKeys = (dim: SubtypeDimension) =>
  [dim.src, dim.dst, dim.other, dim.bi].filter((k): k is string => !!k);

export const getAppProtocolColKey = ({ app_protocol }: AppProtocolRaw, { custom_column }: AppProtocolColumn) =>
  `ktappprotocol__${app_protocol}__${custom_column}`;

export const getAppProtocolUnitKey = (appProtocol: AppProtocolRaw, column: AppProtocolColumn) => {
  const colKey = getAppProtocolColKey(appProtocol, column);
  return column.metadata.hll ? `unique_${colKey}` : colKey;
};

export const getAppProtocolAlias = (column: AppProtocolColumn) => {
  const {
    custom_column,
    metadata: { metric_type: metricType = 'sum', hll, is_count }
  } = column;
  const custom_column_lower = custom_column.toLowerCase();
  let alias = `f_${metricType}_${custom_column_lower}`;
  if (hll) {
    alias = `f_hll(${custom_column_lower}.agg0,0.0001)`;
  } else if (is_count && custom_column_lower === 'i_count' && metricType === 'sum') {
    alias = 'trautocount';
  }
  return alias;
};

export const assignDimensionToDirection = (
  colKey: string,
  label: string,
  direction: string,
  container: { src: Record<string, string>; dst: Record<string, string>; other: Record<string, string> }
) => {
  if (direction === 'source') {
    container.src[colKey] = label.replace(/source\s/i, '');
  } else if (direction === 'destination') {
    container.dst[colKey] = label.replace(/destination\s/i, '');
  } else {
    container.other[colKey] = label;
  }
};

export function getInverseAndDirection(col_name: string) {
  let inverse: string | null = null;
  let direction: string | null = null;
  if (IN_REGEXP.test(col_name)) {
    inverse = col_name.replace(IN_REGEXP, '_out$1');
    direction = 'src';
  } else if (OUT_REGEXP.test(col_name)) {
    inverse = col_name.replace(OUT_REGEXP, '_in$1');
    direction = 'dst';
  } else if (TO_REGEXP.test(col_name)) {
    inverse = col_name.replace(TO_REGEXP, '_from$1');
    direction = 'src';
  } else if (FROM_REGEXP.test(col_name)) {
    inverse = col_name.replace(FROM_REGEXP, '_to$1');
    direction = 'dst';
  } else if (SRC_REGEXP.test(col_name)) {
    inverse = col_name.replace(SRC_REGEXP, '_dst$1');
    direction = 'src';
  } else if (DST_REGEXP.test(col_name)) {
    inverse = col_name.replace(DST_REGEXP, '_src$1');
    direction = 'dst';
  } else if (col_name.includes('Src')) {
    inverse = col_name.replace('Src', 'Dst');
    direction = 'src';
  } else if (col_name.includes('Dst')) {
    inverse = col_name.replace('Dst', 'Src');
    direction = 'dst';
  }
  return { inverse, direction };
}
